




















import { Component, Prop, Vue } from 'vue-property-decorator'
import ChevronDown from 'vue-material-design-icons/ChevronDown.vue'
import ChevronUp from 'vue-material-design-icons/ChevronUp.vue'
import VButton from '@/components/VButton.vue'

@Component({ components: { ChevronDown, ChevronUp, VButton } })
export default class VDropdown extends Vue {
  @Prop({ default: () => [] }) options!: Array<{ label: string; value: any }>
  @Prop({ default: null }) value!: string
  @Prop() label!: string
  @Prop({ default: null }) placeholder!: string
  @Prop({ default: false }) disabled!: boolean

  private expand = false
  private selectedLabel = ''

  private handleClick (value: string, label: string) {
    this.$emit('update:value', value)
    this.expand = false
    this.selectedLabel = label
  }
}
